// Last loaded dashboard data per "<userId>:<entityId>", kept in memory while
// the app is open (cleared on logout). Lets the dashboard show the previous
// data instantly when the user comes back and refresh it in the background.
export const dashboardSnapshots = new Map<string, any>();

export const snapshotKey = (userId: unknown, entityId: unknown) =>
  `${userId}:${entityId}`;

export const clearDashboardSnapshots = () => dashboardSnapshots.clear();
